import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import CustomerProfileCard from './CustomerProfileCard';
import BookingHistoryPanel from './BookingHistoryPanel';

export default function CustomerDetailView({
  customerDetails, detailsLoading, locations, staffMap,
  onBack, onEditEmail, onDeactivate, onActivate,
}) {
  return (
    <div className="animate-slide-up">
      <Button
        variant="ghost"
        onClick={onBack}
        className="mb-4"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Customers
      </Button>

      {detailsLoading ? (
        <div className="text-center py-8">Loading customer details...</div>
      ) : customerDetails ? (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <CustomerProfileCard
            customerDetails={customerDetails}
            onEditEmail={onEditEmail}
            onDeactivate={onDeactivate}
            onActivate={onActivate}
          />
          <BookingHistoryPanel
            bookings={customerDetails.bookings}
            locations={locations}
            staffMap={staffMap}
          />
        </div>
      ) : (
        <div className="text-center py-8 text-muted-foreground">
          Failed to load customer details
        </div>
      )}
    </div>
  );
}
